<template>
  <div class="item-concent" @click="goto">
    <div>
      <img :src="item.image" class="item-img" alt="商品图片">
    </div>
    <div>
      <div class="item-name">{{ item.commonName }}</div>
      <div class="item-norm">{{ item.norm }}</div>
      <div class="item-manufacturer">{{ item.manufacturer }}</div>
      <div class="layout">
        <span class="item-price">{{ item.showPrice }}</span>
        <span class="item-shop">{{ item.shopName }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['item'],
  methods: {
    goto () {
      this.$store.commit('addVisitedItem', this.item.id)
      this.$router.push({ path: '/item', query: { id: this.item.id }})
    }
  }
}
</script>
<style scoped>
  .item-img{
    margin-left: 5px;
    margin-top: 5px;
    display: inline-block;
    width: 100px;
    height: 100px;
  }
  .item-concent{
    display: flex;
    width: 270px;
    height: 130px;
    background-color: white;
  }
  .item-name{
    margin-left: 5px;
    text-align: left;
    font-size: 18px;
    font-weight: 600
  }
  .item-manufacturer{
    height: 45px;
    margin-left: 5px;
    width: 150px;
    text-align: left;
    font-size: 14px;
  }
  .item-norm{
    margin-left: 5px;
    text-align: left;
    font-size: 14px;
  }
  .item-shop{
    margin-right: 0px;
    margin-top: -10px;
    display:inline-block;
    text-align: right;
    width: 80px;
    font-size: 10px;
    color: #acd7f8;
  }
  .item-price{
    margin-left: 5px;
    display: inline-block;
    text-align: left;
    font-size: 20px;
    color:#fe4b47
  }
  .layout{
    display:flex;
    justify-content:space-between
  }
</style>
